import styled from 'styled-components/macro';

export const WhiteBox = styled.div`
  width: 500px;
  padding: 20px;
  background-color: white;
  display: flex;
  justify-content: center;
  border-radius: 15px;
  flex-direction: column;
`;

export const Holder = styled.div`
  align-self: center;
  margin-top: 30px;
`;

export const Text = styled.div`
  align-self: center;
  text-align: center;
  font-size: 35px;
  margin: 10px;
`;

export const Four04 = styled.div`
  align-self: center;
  text-align: center;
  font-size: 55px;
  margin: 10px;
`;
